module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.8028/img/platinum-tier-icon-bordered.svg"